import { render, staticRenderFns } from "./CompSearch.vue?vue&type=template&id=647dde2a&scoped=true"
import script from "./CompSearch.vue?vue&type=script&lang=js"
export * from "./CompSearch.vue?vue&type=script&lang=js"
import style0 from "./CompSearch.vue?vue&type=style&index=0&id=647dde2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647dde2a",
  null
  
)

export default component.exports